import { render, staticRenderFns } from "./AAvatarV2.vue?vue&type=template&id=43bc6b12&scoped=true&"
import script from "./AAvatarV2.vue?vue&type=script&lang=js&"
export * from "./AAvatarV2.vue?vue&type=script&lang=js&"
import style0 from "./AAvatarV2.vue?vue&type=style&index=0&id=43bc6b12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bc6b12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VImg,VSheet})
